import { createRouter, createWebHistory } from 'vue-router';
import LoginView from '../views/LoginView.vue';
import store from '@/store';

const routes = [
  {
    path: '/',
    name: 'login',
    component: LoginView,
    meta: { showNavBar: false, showCanvasBG: true }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/DashboardView.vue'),
    meta: { showNavBar: true, showCanvasBG: false, requiresAuth: true }
  },
  {
    path: '/account',
    name: 'account',
    component: () => import(/* webpackChunkName: "account" */ '../views/AccountView.vue'),
    meta: { showNavBar: true, showCanvasBG: false, requiresAuth: true }
  },
  {
    path: '/service-orders',
    name: 'service-orders',
    component: () => import('@/views/ServiceOrdersView.vue'),
    meta: { showNavBar: true, showCanvasBG: false, requiresAuth: true },
    props: true,
  },
  {
    path: '/history',
    name: 'history',
    component: () => import(/* webpackChunkName: "history" */ '../views/HistoryLogView.vue'),
    meta: { showNavBar: true, showCanvasBG: false, requiresAuth: true },
    props: true,
  },
  // Редирект со старых путей на dashboard
  {
    path: '/users',
    redirect: { name: 'dashboard' }
  },
  {
    path: '/shops',
    redirect: { name: 'dashboard' }
  },
  {
    path: '/drivers',
    redirect: { name: 'dashboard' }
  },
  {
    path: '/trucks',
    redirect: { name: 'service-orders' }
  },
  // Добавляем фолбек маршрут для перенаправления на dashboard при неизвестных маршрутах
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    redirect: (to) => {
      // Если пользователь авторизован, перенаправляем на dashboard
      const isLogged = localStorage.getItem('lbIsLogged') === 'true';
      if (isLogged) {
        return { name: 'dashboard' };
      }
      // Иначе на логин
      return { name: 'login' };
    }
  }
];

const router = createRouter({
  // Используем createWebHistory с правильным базовым путем
  history: createWebHistory(process.env.NODE_ENV === 'production' ? '/' : '/'),
  routes
});

// Navigation guard
router.beforeEach(async (to, from, next) => {
  // Проверяем, залогинен ли пользователь
  const isLogged = store.state.users.user.isLogged;
  const token = localStorage.getItem('lbToken');
  const hasLocalToken = !!token && localStorage.getItem('lbIsLogged') === 'true';



  // Если маршрут требует авторизации и пользователь не залогинен
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isLogged && !hasLocalToken) {
      // Сохраняем путь для восстановления после логина
      if (to.fullPath !== '/' && to.fullPath !== '/login') {
        localStorage.setItem('redirectAfterLogin', to.fullPath);
      }
      // Перенаправление на страницу входа

      next({ name: 'login' });
    } else {
      // Пользователь авторизован
      
      next();
    }
  } else if (to.name === 'login' && (isLogged || hasLocalToken)) {
    // Если пользователь залогинен и пытается перейти на страницу входа
    
    next({ name: 'dashboard' });
  } else {
    // Для маршрутов, не требующих авторизации
    
    next();
  }
});

export default router;
